import { ThreeRow } from "../../core/layouts";
import { addUserFormFieldNames } from "../../validationSchema/addUserManagementSchema";
import BasicDetailsContainer from "../BasicDetailsContainer";
import UserRoleDetailsContainer from "../UserRoleDetailsContainer";
import UserProductAndSubProductFormContainer from "../UserProductAndSubProductFormContainer";
import variables from "../../themes/base/styles/variables";
import UploadAddUserFormImageContainer from "../UploadAddUserFormImageContainer/UploadAddUserFormImageContainer";
import AdditionEmailContainer from "../AdditionalEmailContainer";
import ProductAndSubProductViewOnlyContainer from "../ProductAndSubProductViewOnlyContainer";
import OperationAndRepairAuditContainer from "../OperationAndRepairAuditContainer/OperationAndRepairAuditContainer";
import useResponsive from "../../core/hooks/useResponsive";
import { userRole } from "../../constants";
import GlobalIdFieldComponent from "../../components/GlobalIdFieldComponent/GlobalIdFieldComponent";
import {
  getLocalizedMessage,
  getValueOnCondition,
} from "../../UtilityFunctions/utils";
import { useIntl } from "react-intl";
import ChangePasswordModal from "../ChangePassword";
import { useContext, useState } from "react";
import { Button } from "react_reusable_components";
import Style from "./AddUserFormContainer.module.scss";
import HeadingContainer from "../../containers/HeadingContainer/HeadingContainer";
import { AuthContext } from "../../globalContext/auth/authProvider";

export const AddUserFormContainerStyle = {
  middleSectionStyle: {
    marginTop: variables.marginLarge,
    marginBottom: variables.marginMediumSmall,
  },
  headerText: {
    fontWeight: variables.fontWeightNormal,
    fontSize: variables.fontSizeSmall,
    lineHeight: variables.lineHeightNormal,
    color: variables.textDefault,
  },
  topSectionStyle: {
    marginTop: variables.marginMedium,
  },
  bottomSectionStyle: {
    marginTop: variables.marginMediumLarge1,
  },
  checkboxTextStyle: {
    fontWeight: variables.fontWeightNormal,
    fontsize: variables.fontSizeNormal,
    lineHeight: variables.lineHeightSmall,
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    color: variables.textDefault,
  },
  bottomSectionWrapperStyle: {
    width: variables.fullWidth,
  },
  threeRowSectionStyle: {
    overflow: variables.overflowUnset,
  },
  globalIdContainerStyle: {
    marginTop: variables.marginMediumSmall,
    marginBottom: variables.marginLg3,
    width: "32.5%",
  },
  bottomSectionCheckboxWrapperStyle: {
    width: variables.fullWidth,
  },
  globalIdContainerStyleMobile: {
    marginTop: variables.marginMediumSmall,
    marginBottom: variables.marginLg3,
    width: variables.fullWidth,
  },
};

export default function AddUserFormContainer({
  handleChange,
  values,
  errors,
  setFieldValue,
  setCountryId,
  productSubProductsOptions,
  setSelectedProductAndSubProductOptionsDNSD,
  setSelectedProductAndSubProductOptionsTM,
  selectedImage,
  setSelectedImage,
  additionalEmails,
  setAdditionalEmails,
  isOperationAuditForDNSD,
  isRepairAuditForDNSD,
  isOperationAuditForTM,
  isRepairAuditForTM,
  setIsOperationAuditForDNSD,
  setIsRepairAuditForDNSD,
  setIsRepairAuditForTM,
  setIsOperationAuditForTM,
  touched,
  additionalEmailError,
  setAdditionalEmailError,
  setImageUrl,
  setCountryCodeValue,
  countryCodeValue,
  handleBlur,
  validateField,
  setFieldTouched,
  selectedProductAndSubProductOptionsDNSD,
  selectedProductAndSubProductOptionsTM,
  isEditMode,
  imageId,
}) {
  const responsive = useResponsive();
  const intl = useIntl();
  const authState = useContext(AuthContext)[0];

  const [open, setOpen] = useState();
  const showUploadImageContainer = values[
    addUserFormFieldNames.ROLES_ID
  ]?.includes(userRole.TM);

  const showAdditionalEmailsContainer = values[
    addUserFormFieldNames.ROLES_ID
  ]?.includes(userRole.DNSD);

  const showProductsAndSubProductsCategoryViewOnlyMode = values[
    addUserFormFieldNames.ROLES_ID
  ]?.includes(userRole.CA);

  const showContainerForDNSD = values[addUserFormFieldNames.ROLES_ID]?.includes(
    userRole.DNSD
  );

  const showContainerForTM = values[addUserFormFieldNames.ROLES_ID]?.includes(
    userRole.TM
  );

  const isCountrySelected = !!values[addUserFormFieldNames.COUNTRY_ID];

  return (
    <>
      {open && (
        <ChangePasswordModal open={open} onClose={() => setOpen(false)} />
      )}
      <ThreeRow
        style={AddUserFormContainerStyle.threeRowSectionStyle}
        topSection={
          <BasicDetailsContainer
            handleChange={handleChange}
            values={values}
            errors={errors}
            setFieldValue={setFieldValue}
            touched={touched}
            countryCodeValue={countryCodeValue}
            setCountryCodeValue={setCountryCodeValue}
            handleBlur={handleBlur}
            validateField={validateField}
            setFieldTouched={setFieldTouched}
          />
        }
        middleSectionStyle={AddUserFormContainerStyle.middleSectionStyle}
        middleSection={
          <div style={{ width: "100%" }}>
            {authState?.currentRole?.id === userRole.ADMIN &&
              isEditMode &&
              values?.[addUserFormFieldNames.ROLES_ID]?.[0] !==
                userRole.DNSD && (
                <>
                  <div>
                    <HeadingContainer
                      headingClassName={Style["heading-change-pass"]}
                      heading={getLocalizedMessage(
                        intl,
                        "account.changePassword"
                      )}
                      description={getLocalizedMessage(
                        intl,
                        "account.changePasswordDescription"
                      )}
                      descriptionClassName={Style["description-class"]}
                    />
                    <Button
                      className={`${Style["change-password-btn"]} ${
                        !responsive.isMd ? Style["full-width"] : ""
                      }`}
                      onClick={() => setOpen(true)}
                      ghost
                      icon={null}
                    >
                      {getLocalizedMessage(intl, "account.changePassword")}
                    </Button>
                  </div>
                </>
              )}
            <div>
              <UserRoleDetailsContainer
                handleChange={handleChange}
                values={values}
                errors={errors}
                setFieldValue={setFieldValue}
                setCountryId={setCountryId}
                touched={touched}
                setIsRepairAuditForDNSD={setIsRepairAuditForDNSD}
                setIsRepairAuditForTM={setIsRepairAuditForTM}
                setIsOperationAuditForTM={setIsOperationAuditForTM}
                countryCodeValue={countryCodeValue}
                setCountryCodeValue={setCountryCodeValue}
                handleBlur={handleBlur}
                validateField={validateField}
                setFieldTouched={setFieldTouched}
                isEditMode={isEditMode}
              />
            </div>
          </div>
        }
        bottomSection={
          showBottomSection(values) && (
            <ThreeRow
              topSection={
                <div
                  style={
                    AddUserFormContainerStyle.bottomSectionCheckboxWrapperStyle
                  }
                >
                  {showContainerForDNSD &&
                    values[addUserFormFieldNames.ROLES_ID]?.length > 1 && (
                      <div
                        style={getValueOnCondition({
                          condition: responsive.isMd,
                          trueValue:
                            AddUserFormContainerStyle.globalIdContainerStyle,
                          falseValue:
                            AddUserFormContainerStyle.globalIdContainerStyleMobile,
                        })}
                      >
                        <GlobalIdFieldComponent
                          values={values}
                          errors={errors}
                          touched={touched}
                          handleChange={handleChange}
                        />
                      </div>
                    )}
                  {getValueOnCondition({
                    condition: showContainerForTM,
                    trueValue: (
                      <OperationAndRepairAuditContainer
                        roleName={getLocalizedMessage(
                          intl,
                          "userManagement.roleName.tm"
                        )}
                        disableOperationAudit={false}
                        isOperationAudit={isOperationAuditForTM}
                        isRepairAudit={isRepairAuditForTM}
                        setIsOperationAudit={setIsOperationAuditForTM}
                        setIsRepairAudit={setIsRepairAuditForTM}
                      />
                    ),
                    falseValue: null,
                  })}
                  {showContainerForDNSD && (
                    <OperationAndRepairAuditContainer
                      roleName={getLocalizedMessage(
                        intl,
                        "userManagement.roleName.dnsd"
                      )}
                      disableOperationAudit={true}
                      isOperationAudit={isOperationAuditForDNSD}
                      isRepairAudit={isRepairAuditForDNSD}
                      setIsOperationAudit={setIsOperationAuditForDNSD}
                      setIsRepairAudit={setIsRepairAuditForDNSD}
                    />
                  )}
                </div>
              }
              middleSection={
                <div
                  style={AddUserFormContainerStyle.bottomSectionWrapperStyle}
                >
                  {showProductsAndSubProductsCategoryViewOnlyMode &&
                    isCountrySelected && (
                      <ProductAndSubProductViewOnlyContainer
                        productSubProductsOptions={productSubProductsOptions}
                        roleName={getLocalizedMessage(
                          intl,
                          "userManagement.roleName.countryAdmin"
                        )}
                        style={{ marginTop: variables.marginMediumLarge }}
                      />
                    )}
                  {showContainerForDNSD &&
                    isRepairAuditForDNSD &&
                    isCountrySelected && (
                      <UserProductAndSubProductFormContainer
                        roleName={getLocalizedMessage(
                          intl,
                          "userManagement.roleName.densoService"
                        )}
                        productSubProductsOptions={
                          selectedProductAndSubProductOptionsDNSD
                        }
                        setSelectedProductAndSubProductOptions={
                          setSelectedProductAndSubProductOptionsDNSD
                        }
                      />
                    )}

                  {showContainerForTM &&
                    isRepairAuditForTM &&
                    isCountrySelected && (
                      <UserProductAndSubProductFormContainer
                        roleName={getLocalizedMessage(
                          intl,
                          "userManagement.roleName.teamMember"
                        )}
                        productSubProductsOptions={
                          selectedProductAndSubProductOptionsTM
                        }
                        setSelectedProductAndSubProductOptions={
                          setSelectedProductAndSubProductOptionsTM
                        }
                      />
                    )}
                </div>
              }
              bottomSection={
                <div
                  style={AddUserFormContainerStyle.bottomSectionWrapperStyle}
                >
                  {showUploadImageContainer && (
                    <UploadAddUserFormImageContainer
                      selectedImage={selectedImage}
                      setSelectedImage={setSelectedImage}
                      setImageUrl={setImageUrl}
                      imageId={imageId}
                    />
                  )}
                  {showAdditionalEmailsContainer && (
                    <AdditionEmailContainer
                      additionalEmails={additionalEmails}
                      setAdditionalEmails={setAdditionalEmails}
                      values={values}
                      errors={errors}
                      handleChange={handleChange}
                      additionalEmailError={additionalEmailError}
                      setAdditionalEmailError={setAdditionalEmailError}
                      touched={touched}
                    />
                  )}
                </div>
              }
            />
          )
        }
      />
    </>
  );
}

function showBottomSection(values) {
  let isBottomSectionVisible = false;
  if (values[addUserFormFieldNames.ROLES_ID]?.length > 0) {
    if (values[addUserFormFieldNames.ROLES_ID]?.length === 1) {
      if (!values[addUserFormFieldNames.ROLES_ID]?.includes(userRole.ADMIN)) {
        isBottomSectionVisible = true;
      }
    } else {
      isBottomSectionVisible = true;
    }
  }
  return isBottomSectionVisible;
}
